/* eslint-disable */
const $dot = $('.js-dot');
const mobileBreakpoint = window.matchMedia("(max-width: 768px)");
const positionPanelWindow = (currentSlide, mobileBreakpoint) => {
  const $activeDot = $(currentSlide).find('.js-dot');
  const parentOffset = $('.panel').offset();
  const offsetDot = $activeDot.offset();
  const offsetY = offsetDot.top - parentOffset.top;
  let offsetX = offsetDot.left - parentOffset.left;
  const windowWidth = $('.js-panel-window').width();
  const panelWidth = $('.panel').outerWidth();
  if (!mobileBreakpoint.matches) {
    if (windowWidth + offsetX > panelWidth) {
      $('.panel__window').removeAttr('style');
      const rightBoundary = panelWidth - offsetDot.left;
      console.log(rightBoundary);
      $('.panel__window').css('right', rightBoundary);
      $('.panel__window').css('left', 'inital');
    } else {
      $('.panel__window').css('left', offsetX);
    }
  } else {
    $('.panel__window').css('left', 0);
  }
  $('.panel__window').addClass('is-active');
  $('.panel__window').css('top', offsetY);
};
const replaceWindowText = (title, text, link) => {
  $('.js-window-title').text(title);
  $('.js-window-text').text(text);
  $('.js-window-link').attr('href', link);
};
$dot.on('click', e => {
  const $this = $(e.currentTarget);
  const $currentSlide = $this.closest('.panel__slide');
  const activeClass = 'panel__slide--is-active';

  // Replace content in the panel window
  replaceWindowText($currentSlide.data('title'), $currentSlide.data('text'), $currentSlide.data('link'));
  $('.panel__slide').each((i, ele) => {
    if ($(ele).hasClass(activeClass) && $(ele) !== $currentSlide) {
      $(ele).removeClass(activeClass);
    }
    $currentSlide.addClass(activeClass);
    positionPanelWindow($currentSlide, mobileBreakpoint);
  });
});
$(window).on('load', () => {
  $('.panel__slide').each((i, ele) => {
    if ($(ele).hasClass('panel__slide--is-active')) {
      const $currentSlide = $(ele);
      replaceWindowText($currentSlide.data('title'), $currentSlide.data('text'), $currentSlide.data('link'));
      positionPanelWindow($currentSlide, mobileBreakpoint);
    }
  });
});